<template>
    <div class="full" style="height: 100%">
        <pre-page title="返 回" @back="onBack"></pre-page>

        <van-search
                style="margin-top: 10px;margin-bottom: 10px"
                v-model="organName"
                show-action
                label="机构"
                placeholder="请输入机构名"
                @search="onSearch"
        >
            <template #action>
                <div @click="onSearch">查找</div>
            </template>
        </van-search>
        <div class="container" style="height: calc(100% - 120px);" v-if="showData && !loading">
            <div v-for="(item, index) in list" :key="index">
                <mobile-card :show-title="false" :show-footer="true">
                    <template slot="content">
                        <div class="flex-form-info">
                            <span>名称</span>
                            <span>{{item.name}}</span>
                        </div>

                        <div class="flex-form-info">
                            <span>税号</span>
                            <span>{{item.taxNumber}}</span>
                        </div>

                        <div class="flex-form-info">
                            <span>单位地址</span>
                            <span>{{item.address}}</span>
                        </div>

                        <div class="flex-form-info">
                            <span>电话号码</span>
                            <span>{{item.tele}}</span>
                        </div>

                        <div class="flex-form-info">
                            <span>开户银行</span>
                            <span>{{item.depositBank}}</span>
                        </div>

                        <div class="flex-form-info">
                            <span>银行账户</span>
                            <span>{{item.bank}}</span>
                        </div>

                    </template>

                    <template slot="footer">
                        <div class="flex-form-footer">
                            <div class="flex-form-btn" @click="select(item)">
                                <van-icon name="eye-o"/>
                                <span>选择</span>
                            </div>
                        </div>
                    </template>
                </mobile-card>
            </div>
        </div>

        <div class="tips" style="min-height: 200px;line-height: 200px;" v-else-if="!loading">
            <span>暂无信息</span>
        </div>
        <van-loading color="#005423" v-else style="min-height: 200px; line-height: 200px;"/>

    </div>
</template>

<script>
    import log from "utils/log"
    import MobileButton from "components/mobile-button/index";
    import MobileCard from "components/mobile-card/index";
    import apiPayConfirm from "api/pay-confirm";
    import prePage from "components/pre-page/index";

    export default {
        name: 'ticketSearch',
        components: {MobileCard, prePage},
        props: {},
        computed: {
            showData() {
                return this.list.length > 0
            }
        },
        data() {
            return {
                organName: '',
                loading: false,
                list: [],
            }
        },
        methods: {
            select(item) {
                this.$emit('select', item)
            },
            onBack() {
                this.$emit('back')
            },
            onSearch() {
                let startTime = new Date()
                this.loading = true
                let param = {
                    name: this.organName,
                    pageIndex: 1,
                    pageSize: 100,
                }
                apiPayConfirm.ticketList(param).then(res => {
                    this.list = res.data.rows
                })
                this.handle(startTime)
            },
            handle(startTime) {
                this.$nextTick(() => {
                    let t = 800 - (new Date() - startTime)
                    if (t > 0) {
                        setTimeout(() => {
                            this.loading = false
                        }, t);
                    }else{
                        this.loading = false
                    }
                })
            }
        },
        created() {
            this.onSearch()
        },
        mounted() {
        }

    }
</script>

<style lang='scss' scoped>
    .container {
        height: 80%;
        width: 100%;
        overflow-y: auto;
    }

    .tips {
        height: 80%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        span {
            font-size: 24px;
        }
    }

    .footer {
        margin-top: 20px;
    }

</style>
